// Browser-side half of the launched-before cohort filter.
//
// The server owns the CSV (src/lib/pimsLaunch.ts reads it from disk, so it can
// never be imported here) and serves the site -> go-live map from
// /api/launch-dates. This turns that map into the set of sites a cutoff keeps.
//
// Only the RAW path needs this. On the rollup path the filter is applied in SQL,
// so ineligible sites never reach the browser at all -- see fetchRollupPayload.
// The raw path ships every row by design and caches gzipped files named by date
// range alone, so it filters here instead; both paths must agree for compare
// mode to mean anything, and they do because both cut on the same map.

export type LaunchDateMap = Record<string, string>;

export interface LaunchDateOption {
  date: string;
  sites: number;
}

export interface LaunchDatesResponse {
  options: LaunchDateOption[];
  launchDates: LaunchDateMap;
}

// null rather than a set of everything when no cutoff is chosen: applyBaseFilter
// can then skip the pass entirely instead of testing 137k rows against a set
// that cannot reject any of them.
export function eligibleSiteSet(
  launchDates: LaunchDateMap,
  launchedBefore: string | null
): ReadonlySet<string> | null {
  if (!launchedBefore) return null;
  const eligible = new Set<string>();
  for (const [siteId, launchDate] of Object.entries(launchDates)) {
    if (launchDate <= launchedBefore) eligible.add(siteId);
  }
  return eligible;
}
